import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Category } from "../../../@types/Category";
import axiosInstance from "../../../utils/axiosConfig";

export const updateFileType = createAsyncThunk(
  "fileTypes/updateFileType",
  async (fileType: Category, { rejectWithValue }) => {
    try {
      const {
        id,
        name,
        module,
        isSignable,
        datesRequire,
        expirationDays,
        htmlDescription,
        enabled,
        requireCode,
        sendMessageWhatsApp,
        sendMessageSMS,
      } = fileType;

      const { data } = await axiosInstance.patch(`${api.baseURL}category/${id}`, {
        name,
        module,
        isSignable,
        datesRequire,
        expirationDays,
        htmlDescription,
        enabled,
        requireCode,
        sendMessageWhatsApp,
        sendMessageSMS,
      });

      return data as Category;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
